import React, { useState } from "react";
import { PaystackButton } from "react-paystack";

const PaystackCheckout = ({ amount }) => {
  const [formData, setFormData] = useState({
    email: "",
    firstName: "",
    lastName: "",
    phone: ""
  });
  const [processing, setProcessing] = useState(false);
  const [error, setError] = useState(null);
  const publicKey = "your-paystack-public-key";

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevData => ({
      ...prevData,
      [name]: value
    }));
  };

  const validateForm = () => {
    if (!formData.email) return "Email is required";
    if (!formData.email.match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/)) return "Invalid email format";
    if (!formData.firstName) return "First name is required";
    if (!formData.lastName) return "Last name is required";
    if (!formData.phone) return "Phone number is required";
    return null;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const validationError = validateForm();
    if (validationError) {
      setError(validationError);
      return;
    }
    // Proceed with payment
    setProcessing(true);
    setError(null);
  };

  const paystackConfig = {
    email: formData.email,
    amount: amount * 100,
    publicKey,
    currency: "NGN",
    text: processing ? "Processing..." : "Pay Now",
    metadata: {
      custom_fields: [
        {
          display_name: "First Name",
          variable_name: "first_name",
          value: formData.firstName
        },
        {
          display_name: "Last Name",
          variable_name: "last_name",
          value: formData.lastName
        },
        {
          display_name: "Phone",
          variable_name: "phone",
          value: formData.phone
        }
      ]
    },
    onSuccess: (reference) => {
      setProcessing(false);
      console.log("Payment successful:", reference);
      alert(`Payment successful! Reference: ${reference.transaction}`);
    },
    onClose: () => {
      setProcessing(false);
      console.log("Payment closed");
    },
  };

  const isFormValid = !validateForm();

  return (
    <div className="max-w-md mx-auto p-4 bg-white rounded-lg shadow">
      <h2 className="text-lg font-medium text-indigo-900 mb-1">Pay with Paystack</h2>
        <h3 className="text-lg font-medium text-indigo-900 mt-2">₦{amount.toLocaleString()}</h3>
      <p className="text-sm text-gray-500 mb-4">Secure and encrypted payment</p>

      <form onSubmit={handleSubmit}>
        <div className="d-flex flex-column gap-3">
          {/* Email Field */}
          <div className="w-100">
            <label className="d-block text-sm fw-medium text-gray-700 mb-1">Email</label>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              placeholder="your@email.com"
              className="form-control"
              required
            />
          </div>

          {/* Name*/}
          <div className="d-flex gap-3">
            <div className="flex-grow-1">
              <label className="d-block text-sm fw-medium text-gray-700 mb-1">First Name</label>
              <input
                type="text"
                name="firstName"
                value={formData.firstName}
                onChange={handleChange}
                placeholder="First name"
                className="form-control"
                required
              />
            </div>

            <div className="flex-grow-1">
              <label className="d-block text-sm fw-medium text-gray-700 mb-1">Last Name</label>
              <input
                type="text"
                name="lastName"
                value={formData.lastName}
                onChange={handleChange}
                placeholder="Last name"
                className="form-control"
                required
              />
            </div>
          </div>

          {/* Phone Number Field */}
          <div className="w-100">
            <label className="d-block text-sm fw-medium text-gray-700 mb-1">Phone Number</label>
            <input
              type="tel"
              name="phone"
              value={formData.phone}
              onChange={handleChange}
              placeholder="Your phone number"
              className="form-control"
              required
            />
          </div>
        </div>


        {error && (
          <div className="mt-4 p-2 bg-red-50 text-red-500 text-sm rounded">
            {error}
          </div>
        )}

        <div className="mt-6">
          {isFormValid ? (
            <PaystackButton
              {...paystackConfig}
              className="mt-3 btn btn-primary w-full py-2 text-sm font-medium rounded-lg transition duration-200 flex items-center justify-center"
              onMouseDown={() => setProcessing(true)}
              disabled={processing}
            />
          ) : (
            <button
              type="submit"
              disabled={processing}
              className="mt-3 btn btn-primary w-full py-2 text-sm font-medium rounded-lg transition duration-200 flex items-center justify-center"
            >
              {processing ? (
                "Processing..."
              ) : (
                "Pay Now"
              )}
            </button>
          )}
        </div>
      </form>
    </div>
  );
};

export default PaystackCheckout;